module.exports = require('./toPairsIn');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/entriesIn.js
// module id = 1852
// module chunks = 1